/* eslint-disable @typescript-eslint/ban-types */
import { Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import FormToggle from '../../../../../../../Global/Toggle'
import { SingleFieldProps } from '../../../../../../Types'
import { useStyles } from './Style'
import { formateBooleanValue } from './Utils'

const QualificationGuarantorType = <T extends {}>({
  field,
  input,
}: SingleFieldProps<T>): React.ReactElement => {
  const classes = useStyles()
  const [allowed, setAllowed] = useState(false)

  const onAllowedChange = (value: string | boolean) => {
    setAllowed(formateBooleanValue(value))
    input.onChange(formateBooleanValue(value))
  }

  useEffect(() => {
    setAllowed(formateBooleanValue(input.value))
    input.onChange(formateBooleanValue(input.value))
  }, [input.value])

  return (
    <div className={classes.container}>
      <div className={classes.labelContainer}>
        {field.customProperties?.label && field.customProperties?.label !== '' && (
          <Typography className={classes.label}>{field.customProperties?.label}</Typography>
        )}
        {field.customProperties?.subLabel && field.customProperties?.subLabel !== '' && (
          <Typography className={classes.sublabel}>{field.customProperties?.subLabel}</Typography>
        )}
      </div>
      <div className={classes.toggleContainer}>
        <div className={classes.toggleWrapper}>
          <FormToggle
            label={allowed ? 'Garant accepté' : 'Garant refusé'}
            value={formateBooleanValue(input.value) || false}
            onChange={(value: string | boolean) => onAllowedChange(value)}
          />
        </div>
      </div>
    </div>
  )
}

export default QualificationGuarantorType
